import {myAxios} from '../util/myAxios';
import {AccountDto} from './userTypes';

export function getAccount(): Promise<AccountDto> {
  return myAxios()
    .then(axios => axios.get(`/api/account`))
    .then(response => response.data);
}
